import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetectionBrowserService {
  public browserName: string = '';
  public isDirectAccess: boolean = false;

  getBrowserName() {
    const userAgent = navigator.userAgent;

    if ((navigator as any).brave && (navigator as any).brave.isBrave) {
      this.browserName = 'Brave';
    } else if (/Edg\//.test(userAgent)) {
      this.browserName = 'Microsoft Edge';
    } else if (/OPR\//.test(userAgent)) {
      this.browserName = 'Opera';
    } else if (/Chrome\//.test(userAgent) && !/Edg\//.test(userAgent) && !/OPR\//.test(userAgent)) {
      this.browserName = 'Google Chrome';
    } else if (/Safari\//.test(userAgent) && !/Chrome\//.test(userAgent)) {
      this.browserName = 'Safari';
    } else if (/Firefox\//.test(userAgent)) {
      this.browserName = 'Mozilla Firefox';
    } else if (/MSIE |Trident\//.test(userAgent)) {
      this.browserName = 'Internet Explorer';
    } else {
      this.browserName = 'Desconocido';
    }
    this.isDirectAccess = document.referrer === '';
    console.log('Acceso directo:', this.isDirectAccess);
    console.log('Navegador detectado:', this.browserName);
  }
}
